<template>
  <div class="page page-refund">
    <navigation>申请退款</navigation>
    <div class="refund-main">
      <div class="refund-section refund-type">
        <div class="type-label">会员类型</div>
        <div class="type-info">{{refundInfo.goodsName}}</div>
      </div>
      <div class="refund-section refund-reason">
        <div class="reason-title">不可退款原因</div>
        <div class="reason-list">
          <div
            v-for="(item, index) in refundInfo.notRefundReason"
            :key="index"
            class="reason-item"
          >{{item}}</div>
        </div>
      </div>
      <div class="refund-tips">
        如有疑问，请于工作日09:00-18:00，拨打天美贷客服热线{{customerServicePhone}}，或微信搜索“天美贷”微信公众号联系客服
      </div>
    </div>
    <div class="refund-bottom">
      <nd-button @click="serviceVisible = true">联系客服</nd-button>
    </div>
    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：{{customerServicePhone}}</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import RefundProgress from './components/refund-progress.vue'
import { mockHrefJump } from '@/assets/utils'
import { mapActions } from 'vuex'

export default {
  components: {
    RefundProgress
  },
  data () {
    return {
      memberNo: this.$route.query.memberNo,
      customerServicePhone: '4000100008',
      serviceVisible: false,
      refundInfo: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('refund', [
      'refundInitX'
    ]),
    callService () {
      mockHrefJump(`tel:${this.customerServicePhone}`)
    },
    // 初始化
    async init () {
      const { success, data } = await this.refundInitX({
        memberNo: this.memberNo,
        refundWay: 'SERVICE'
      })
      // const { success, data } = {
      //   success: true,
      //   data: {
      //     refundMemberInfo: {
      //       memberNo: '121212',
      //       goodsName: '授信重审卡',
      //       notRefundReason: [
      //         '您已经使用生活权益：这个名字暂时给长一点来个两排左右总可以了吧',
      //         '您已成功借款',
      //         '您当前不满足“7日内首笔提现失败可申请退款”的规则'
      //       ],
      //       refundProcessEnd: false
      //     }
      //   }
      // }
      if (success) {
        // 如果退款结束，直接返回到上一页
        if (data.refundMemberInfo.refundProcessEnd) {
          return this.$router.back()
        }
        this.refundInfo = data.refundMemberInfo
        return this.$bus.$emit('ready')
      }
      this.$bus.$emit('error')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-refund{
  background-color: #F7F7F7;
  .refund-main{
    padding: 40px 30px;
    .refund-section{
      background-color: #fff;
      border-radius: 20px;
      & + .refund-section{
        margin-top: 30px;
      }
    }
    .refund-type{
      display: flex;
      justify-content: space-between;
      padding: 30px;
      align-items: center;
      font-size: 30px;
      color: #333;
      .type-label{
        font-weight: bold;
      }
    }
    .refund-reason{
      font-size: 30px;
      .reason-title{
        padding: 28px 30px 28px 90px;
        background: url(./images/icon_reason@2x.png) 30px center no-repeat;
        background-size: 44px;
        border-bottom: 1PX solid #EEEEEE;
        font-weight: bold;
      }
      .reason-list{
        padding-left: 90px;
        .reason-item{
          display: flex;
          padding: 33px 48px 33px 0;
          line-height: 44px;
          counter-increment: number;
          &::before{
            content: "";
            font-weight: bold;
            color: #fff;
            display: block;
            width: 28px;
            height: 28px;
            // line-height: 44px;
            text-align: center;
            background: linear-gradient(90deg, #FF5C5C 0%, #FD5316 100%);
            border-radius: 50%;
            font-size: 30px;
            flex: 0 0 auto;
            margin-top: 8px;
            margin-right: 16px;
          }
          & + .reason-item{
            border-top: 1PX solid #EEEEEE;
          }
        }
      }
    }
    .refund-tips{
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      margin-top: 42px;
      padding-left: 70px;
      background: url(./images/icon_kefu@2x.png) 20px 0 no-repeat;
      background-size: 34px;
    }
  }  
  .refund-bottom{
    background-color: #fff;
    padding: 28px 50px 58px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
.service-dialog {
  padding-top: 10px;
  padding: 0 48px;
  padding-bottom: 80px;
  font-family: PingFangSC-Regular,PingFang SC;
  .title {
    font-size: 42px;
    height: 72px;
    line-height: 72px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
  }
  .description {
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin-top: 22px;
    font-weight: 400;
  }
  .description1{
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin: 12px auto 12px;
    font-weight: 400;
  }
  .telphone {
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    margin-top: 2px;
    font-weight: 400;
    color: @fc3;
  }
}
</style>